// English translations
const en = {
  // Common
  'site.name': 'Pronova',
  'site.tagline': 'Revolutionary Cryptocurrency for Investment Integration',
  
  // Navigation
  'nav.home': 'Home',
  'nav.features': 'Features',
  'nav.tokenomics': 'Tokenomics',
  'nav.roadmap': 'Roadmap',
  'nav.whitepaper': 'Whitepaper',
  'nav.team': 'Team & Partners',
  'nav.faq': 'FAQ',
  'nav.presale': 'Presale',
  'nav.dashboard': 'Dashboard',
  'nav.login': 'Login',
  'nav.register': 'Register',
  'nav.connect': 'Connect Wallet',
  
  // Hero Section
  'hero.title': 'The Future of Integrated Investment',
  'hero.subtitle': 'Pronova bridges the gap between traditional business and cryptocurrencies, offering revolutionary investment opportunities with 18 global companies.',
  'hero.cta.primary': 'Join Presale',
  'hero.cta.secondary': 'Read Whitepaper',
  'hero.stat.companies': 'Partner Companies',
  'hero.stat.discount': 'Discount When Using PRN',
  'hero.stat.countries': 'Countries Coverage',
  
  // Features Section
  'features.title': 'Why Choose Pronova',
  'features.subtitle': 'Pronova offers unique advantages to investors and businesses',
  'features.card1.title': 'Discount Payments',
  'features.card1.text': 'Receive a 10% discount when using Pronova for payments with partner companies',
  'features.card2.title': 'Business Cashback',
  'features.card2.text': 'Companies that accept Pronova receive cashback, creating a win-win ecosystem',
  'features.card3.title': 'Global Partnerships',
  'features.card3.text': '18 international companies across real estate, gold, insurance and more',
  'features.card4.title': 'Investment Guarantee',
  'features.card4.text': 'Use Pronova as a guarantee for investments, demonstrating confidence in its value',
  'features.card5.title': 'Risk Insurance',
  'features.card5.text': 'Protected by insurance policies against cyber threats and data breaches',
  'features.card6.title': 'Real-World Utility',
  'features.card6.text': 'Immediate utility for payments, investments, and more across partner companies',
  
  // Tokenomics Section
  'tokenomics.title': 'Tokenomics',
  'tokenomics.subtitle': 'Balanced allocation for sustainable growth and participation',
  'tokenomics.total': 'Total Supply',
  'tokenomics.symbol': 'Symbol',
  'tokenomics.blockchain': 'Blockchain',
  'tokenomics.founders': 'Founders',
  'tokenomics.liquidity': 'Liquidity',
  'tokenomics.partnerships': 'Partnerships',
  'tokenomics.team': 'Team',
  'tokenomics.presale': 'Presale',
  'tokenomics.community': 'Community',
  'tokenomics.reserves': 'Strategic Reserves',
  'tokenomics.marketing': 'Marketing & Development',
  'tokenomics.locked': 'Locked Tokens',
  'tokenomics.locked.text': '56% of tokens will be locked for 7 years with 4% unlocked every 6 months',
  
  // Presale Section
  'presale.title': 'Join the Presale',
  'presale.subtitle': 'Get in early on the revolutionary Pronova cryptocurrency',
  'presale.phase': 'Phase',
  'presale.duration': 'Duration',
  'presale.tokens': 'Tokens',
  'presale.price': 'Price',
  'presale.raised': 'Raised',
  'presale.phase1': 'Phase 1',
  'presale.phase2': 'Phase 2',
  'presale.phase3': 'Phase 3',
  'presale.days': 'days',
  'presale.total': 'Total',
  'presale.million': 'Million',
  'presale.listing': 'Expected Listing Price',
  'presale.cta': 'Buy Tokens Now',
  'presale.counter.days': 'Days',
  'presale.counter.hours': 'Hours',
  'presale.counter.minutes': 'Minutes',
  'presale.counter.seconds': 'Seconds',
  
  // Calculator
  'calculator.title': 'Investment Calculator',
  'calculator.subtitle': 'Calculate your potential PRN tokens and future value',
  'calculator.invest': 'Investment Amount',
  'calculator.currency': 'Currency',
  'calculator.receive': 'PRN Tokens You Receive',
  'calculator.future': 'Future Value at Listing',
  'calculator.min': 'Min',
  'calculator.max': 'Max',
  'calculator.calculate': 'Calculate',
  
  // Partners Section
  'partners.title': 'Our Partners',
  'partners.subtitle': 'Pronova is supported by established companies across multiple sectors',
  'partners.cta': 'View All Partners',
  
  // Roadmap Page
  'roadmap.title': 'Pronova Roadmap',
  'roadmap.subtitle': 'Our strategic development plan, from initial launch to global adoption',
  'roadmap.timeline': 'Development Timeline',
  'roadmap.timeline.subtitle': 'A comprehensive view of our journey, current progress, and future milestones',
  'roadmap.vision.title': 'Our Vision for The Future',
  'roadmap.vision.text1': 'At Pronova, we\'re building more than just a cryptocurrency. We\'re creating an entire ecosystem that bridges the gap between traditional finance and blockchain technology.',
  'roadmap.vision.text2': 'Our roadmap is designed to ensure steady, sustainable growth while continually adding real-world utility and value for our token holders. Each milestone is carefully planned to build upon previous achievements.',
  'roadmap.vision.text3': 'By 2027, we envision Pronova as a leading digital asset used worldwide for payments, investments, and transactions, with deep integration into both traditional and decentralized financial systems.',
  'roadmap.pillars.title': 'Key Development Pillars',
  'roadmap.pillar1.title': 'Security First Approach',
  'roadmap.pillar1.text': 'Multiple security audits and continuous monitoring to ensure asset protection',
  'roadmap.pillar2.title': 'Real-World Utility',
  'roadmap.pillar2.text': 'Practical applications in payments, investments, and business operations',
  'roadmap.pillar3.title': 'Strategic Partnerships',
  'roadmap.pillar3.text': 'Collaboration with established companies and financial institutions',
  'roadmap.pillar4.title': 'Technological Innovation',
  'roadmap.pillar4.text': 'Continuous improvement of our blockchain infrastructure and features',
  'roadmap.pillar5.title': 'Community Empowerment',
  'roadmap.pillar5.text': 'Engaging and rewarding our community members as we grow',
  'roadmap.cta.title': 'Join Us on This Journey',
  'roadmap.cta.text': 'Be part of the Pronova revolution and contribute to shaping the future of cryptocurrency integration with traditional finance.',
  'roadmap.cta.primary': 'Join Presale',
  'roadmap.cta.secondary': 'Join Community',
  
  // Whitepaper Page
  'whitepaper.title': 'Pronova Whitepaper',
  'whitepaper.subtitle': 'Comprehensive details about Pronova cryptocurrency, its features, tokenomics, roadmap, and vision for the future.',
  'whitepaper.download': 'Download PDF',
  'whitepaper.read': 'Read Online',
  'whitepaper.contents': 'Whitepaper Contents',
  'whitepaper.section.summary': 'Executive Summary',
  'whitepaper.section.intro': 'Introduction',
  'whitepaper.section.features': 'Features & Support',
  'whitepaper.section.tokenomics': 'Tokenomics',
  'whitepaper.section.roadmap': 'Roadmap',
  'whitepaper.section.team': 'Team & Consultants',
  'whitepaper.section.partners': 'Partners',
  'whitepaper.section.risks': 'Risks & Challenges',
  'whitepaper.section.legal': 'Law & Compliance',
  'whitepaper.section.conclusion': 'Conclusion',
  'whitepaper.download.full': 'Download Complete Whitepaper',
  
  // Team Page
  'team.title': 'Our Team & Partners',
  'team.subtitle': 'Pronova is backed by a strong network of established companies and organizations with expertise in finance, blockchain, real estate, and more.',
  'team.core': 'Core Team',
  'team.core.subtitle': 'The companies and organizations leading the Pronova project',
  'team.structure': 'Team Structure',
  'team.structure.text': 'Pronova\'s team, companies, diversity, and success are managed by teams, groups, companies, and entities and are not subject to one person, one property, or one official, but there are multiple responsibilities, powers, and control.',
  'team.supervisory': 'Supervisory Board',
  'team.supervisory.text': 'A team composed of Capimax for Financial and Risk Management, Cryptocurrencies, CoverTech Insurance & Risk, CIM Financial, and Ashorax Risk Assurance.',
  'team.advisory': 'Advisory Board',
  'team.advisory.text': 'Includes CoverTech Insurance & Credit Risk Company, CAPIMax Risk Management Company, and CIM Finance.',
  'team.management': 'Management Team',
  'team.management.text': 'Owned by Pronova Virtual Asset (Wyoming, USA) and operated in partnership with the Capimax Group ecosystem.',
  'team.partners': 'Strategic Partners',
  'team.partners.subtitle': 'The companies and organizations that support and collaborate with Pronova',
  'team.benefits': 'Partnership Benefits',
  'team.benefits.text1': 'Our strategic partnerships create a powerful ecosystem that benefits all participants in the Pronova network.',
  'team.benefits.text2': 'Partners offer customers up to 10% discount when paying in Pronova, while companies receive cashback, creating a sustainable economic model.',
  'team.benefits.text3': 'These agreements are registered on the companies\' official websites and have already entered into force, providing immediate utility for Pronova token holders.',
  'team.network': 'How Our Partnership Network Benefits You',
  'team.benefit1.title': 'Real Estate Investment',
  'team.benefit1.text': 'Use Pronova for real estate purchases with a 10% discount through partner companies',
  'team.benefit2.title': 'Precious Metals & Gold',
  'team.benefit2.text': 'Invest in gold and precious metals with special discounts for Pronova holders',
  'team.benefit3.title': 'Insurance Services',
  'team.benefit3.text': 'Access specialized insurance for digital assets and get preferred rates',
  'team.benefit4.title': 'Hospitality & Travel',
  'team.benefit4.text': 'Book hotels and travel services with exclusive discounts using Pronova',
  'team.benefit5.title': 'Investment Opportunities',
  'team.benefit5.text': 'Gain access to exclusive investment products offered by CAPIMAX',
  'team.insurance': 'Risk Insurance & Asset Protection',
  'team.insurance.subtitle': 'Our partnership with insurance companies provides comprehensive protection',
  'team.insurance.text': 'CoverTech has been contracted to insure digital assets and currencies to provide protection and financial support in the event of data breaches, cyber attacks, cyber threats, business interruption coverage resulting from cyber incidents, and legal and regulatory expenses and fines.',
  'team.security': 'Data Security',
  'team.security.point1': 'Protection against data breaches',
  'team.security.point2': 'Regular security assessments',
  'team.security.point3': 'Data encryption standards',
  'team.cyber': 'Cyber Protection',
  'team.cyber.point1': 'Safeguards against cyber attacks',
  'team.cyber.point2': 'Continuous monitoring',
  'team.cyber.point3': 'Rapid incident response',
  'team.business': 'Business Continuity',
  'team.business.point1': 'Coverage for business interruption',
  'team.business.point2': 'Legal and regulatory expense coverage',
  'team.business.point3': 'Risk management consulting',
  'team.insurance.link': 'View the Insurance Document on the Official Website',
  'team.cta.title': 'Join the Pronova Ecosystem',
  'team.cta.text': 'Become part of an innovative cryptocurrency project backed by established global companies with real-world utility and secure asset protection.',
  'team.cta.primary': 'Join Presale',
  'team.cta.secondary': 'Read Whitepaper',
  
  // FAQ Page
  'faq.title': 'Frequently Asked Questions',
  'faq.subtitle': 'Find answers to the most common questions about Pronova cryptocurrency',
  'faq.category.general': 'General',
  'faq.category.tokenomics': 'Tokenomics',
  'faq.category.presale': 'Presale',
  'faq.category.partnerships': 'Partnerships',
  'faq.category.investment': 'Investment',
  'faq.category.security': 'Security',
  'faq.more.title': 'Still Have Questions?',
  'faq.more.text': 'If you couldn\'t find the answers you were looking for, feel free to reach out to our team directly.',
  'faq.more.contact': 'Contact Support',
  'faq.more.telegram': 'Join Our Telegram',
  'faq.resources': 'Additional Resources',
  'faq.resources.text': 'Explore these resources to learn more about Pronova cryptocurrency and its ecosystem',
  'faq.resource1.title': 'Whitepaper',
  'faq.resource1.text': 'Detailed information about Pronova\'s technology, tokenomics, and vision',
  'faq.resource1.cta': 'Read Whitepaper',
  'faq.resource2.title': 'Roadmap',
  'faq.resource2.text': 'Our development timeline and future milestones for Pronova',
  'faq.resource2.cta': 'View Roadmap',
  'faq.resource3.title': 'Team & Partners',
  'faq.resource3.text': 'Learn about the companies and organizations behind Pronova',
  'faq.resource3.cta': 'Meet the Team',
  'faq.cta.title': 'Ready to Join the Presale?',
  'faq.cta.text': 'Don\'t miss out on the opportunity to be part of the revolutionary Pronova cryptocurrency at the best price',
  'faq.cta.button': 'Join Presale Now',
  
  // Dashboard
  'dashboard.title': 'Presale Dashboard',
  'dashboard.subtitle': 'Track your investments and Pronova holdings',
  'dashboard.presale.status': 'Presale Status',
  'dashboard.presale.raised': 'Raised So Far',
  'dashboard.presale.goal': 'Goal',
  'dashboard.presale.progress': 'Progress',
  'dashboard.presale.participants': 'Participants',
  'dashboard.presale.remaining': 'Time Remaining',
  'dashboard.your.tokens': 'Your PRN Tokens',
  'dashboard.your.contribution': 'Your Contribution',
  'dashboard.your.bonus': 'Your Bonus Tokens',
  'dashboard.your.total': 'Total Tokens',
  'dashboard.buy.more': 'Buy More Tokens',
  'dashboard.referral.title': 'Referral Program',
  'dashboard.referral.text': 'Share your referral link and earn 5% of the PRN tokens purchased by your referrals',
  'dashboard.referral.link': 'Your Referral Link',
  'dashboard.referral.copy': 'Copy Link',
  'dashboard.referral.total': 'Total Referral Bonus',
  'dashboard.referral.count': 'Number of Referrals',
  'dashboard.transaction.title': 'Transaction History',
  'dashboard.transaction.date': 'Date',
  'dashboard.transaction.type': 'Type',
  'dashboard.transaction.amount': 'Amount',
  'dashboard.transaction.tokens': 'Tokens',
  'dashboard.transaction.status': 'Status',
  'dashboard.transaction.purchase': 'Purchase',
  'dashboard.transaction.referral': 'Referral Bonus',
  'dashboard.transaction.completed': 'Completed',
  'dashboard.transaction.pending': 'Pending',
  
  // Footer
  'footer.rights': 'All Rights Reserved',
  'footer.disclaimer': 'Cryptocurrency investments are subject to market risks. Please read our whitepaper before investing.',
  'footer.links': 'Quick Links',
  'footer.community': 'Community',
  'footer.legal': 'Legal',
  'footer.terms': 'Terms & Conditions',
  'footer.privacy': 'Privacy Policy',
  'footer.disclaimer.link': 'Disclaimer',
  'footer.contact': 'Contact Us',
  'footer.subscribe': 'Subscribe to Updates',
  'footer.subscribe.placeholder': 'Your Email Address',
  'footer.subscribe.button': 'Subscribe',
};

export default en;